"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
const constants_1 = require("./constants");
const layers_1 = require("../../../services/layers");
const constants_2 = require("../../../utils/constants");
const createEditableTextLayer = _ref => {
  let {
    designId,
    x,
    y,
    height,
    width,
    zIndex,
    isCompositeDesign,
    activePage,
    existingTextLayers
  } = _ref;
  let id = `layer_${designId}_${x}x${y}_${width}x${height}_editable_text_all`;
  const numDuplicates = existingTextLayers.filter(layer => layer.id.includes(id)).length;
  if (numDuplicates > 0) {
    id = id.concat(`_${numDuplicates}`);
  }
  if (isCompositeDesign && activePage !== layers_1.CoverageType.LEFT) {
    id = id + constants_2.SHIFTED_RIGHT_APPENDIX;
  }
  return {
    id: id,
    name: id,
    type: 'editable_text',
    zIndex,
    height,
    width,
    x,
    y,
    rotate: 0,
    defaultData: {
      content: '',
      style: {
        color: constants_1.COLOR,
        fontFamily: constants_1.FONTFAMILY,
        fontSize: constants_1.FONTSIZE,
        textAlign: constants_1.TEXTALIGN,
        textTransform: constants_1.TEXTTRANSFORM
      },
      styleRestrictions: {}
    },
    userCanMove: true,
    userCanResize: true
  };
};
exports.default = createEditableTextLayer;